import { HTTP_METHOD, JSON_HEADERS, PAYMENT_PAGE_API_PATH } from "./paymentPage.constants";

const API_BASE_URL = process.env.REACT_APP_API_URL;
const OBJECT_TYPE = "object";
const TEXT_TYPE = "string";
const PATH_SEPARATOR = "/";
const NO_REFUSAL = "NONE";
const GET_OPTIONS = Object.freeze({ method: HTTP_METHOD.GET });
const POST_WITHOUT_BODY_OPTIONS = Object.freeze({ method: HTTP_METHOD.POST });

export class PaymentPageRequestError extends Error {
    constructor(httpStatus, refusal, message) {
        super(message);
        this.name = "PaymentPageRequestError";
        this.httpStatus = httpStatus;
        this.refusal = refusal;
    }
}

function isObject(value) {
    if (typeof value !== OBJECT_TYPE) {
        return false;
    }
    return value !== null;
}

function readRefusal(responseBody) {
    if (isObject(responseBody.data) === false) {
        return NO_REFUSAL;
    }
    if (typeof responseBody.data.refusal !== TEXT_TYPE) {
        return NO_REFUSAL;
    }
    return responseBody.data.refusal;
}

function buildPaymentLinkPageAddress(paymentLinkId) {
    return API_BASE_URL + PAYMENT_PAGE_API_PATH.PAYMENT_LINKS + encodeURIComponent(paymentLinkId);
}

function buildPaymentLinkAddress(paymentLinkId, pathSuffix) {
    return buildPaymentLinkPageAddress(paymentLinkId) + pathSuffix;
}

function buildAttemptPath(attemptId, actionPath) {
    return PAYMENT_PAGE_API_PATH.ATTEMPTS + PATH_SEPARATOR + encodeURIComponent(attemptId) + actionPath;
}

function buildPostOptions(requestBody) {
    return { method: HTTP_METHOD.POST, headers: JSON_HEADERS, body: JSON.stringify(requestBody) };
}

async function sendPaymentPageRequest(address, requestOptions) {
    const response = await fetch(address, requestOptions);
    const responseBody = await response.json();
    if (response.ok === false) {
        throw new PaymentPageRequestError(response.status, readRefusal(responseBody), responseBody.message);
    }
    return responseBody.data;
}

export function fetchPaymentLinkPage(paymentLinkId) {
    return sendPaymentPageRequest(buildPaymentLinkPageAddress(paymentLinkId), GET_OPTIONS);
}

export function openCheckoutSession(paymentLinkId) {
    return sendPaymentPageRequest(
        buildPaymentLinkAddress(paymentLinkId, PAYMENT_PAGE_API_PATH.CHECKOUT_SESSIONS),
        POST_WITHOUT_BODY_OPTIONS
    );
}

export function startPaymentAttempt(paymentLinkId, checkoutSession) {
    return sendPaymentPageRequest(
        buildPaymentLinkAddress(paymentLinkId, PAYMENT_PAGE_API_PATH.ATTEMPTS),
        buildPostOptions({ sessionId: checkoutSession.id, sessionData: checkoutSession.data })
    );
}

export function sendBankCheckStart(paymentLinkId, attemptId) {
    return sendPaymentPageRequest(
        buildPaymentLinkAddress(paymentLinkId, buildAttemptPath(attemptId, PAYMENT_PAGE_API_PATH.BANK_CHECK)),
        POST_WITHOUT_BODY_OPTIONS
    );
}

export function sendPaymentDetails(paymentLinkId, attemptId, paymentData) {
    return sendPaymentPageRequest(
        buildPaymentLinkAddress(paymentLinkId, buildAttemptPath(attemptId, PAYMENT_PAGE_API_PATH.DETAILS)),
        buildPostOptions({ data: paymentData })
    );
}

export function sendPaymentResult(paymentLinkId, attemptId, sessionResult) {
    return sendPaymentPageRequest(
        buildPaymentLinkAddress(paymentLinkId, buildAttemptPath(attemptId, PAYMENT_PAGE_API_PATH.RESULT)),
        buildPostOptions({ sessionResult })
    );
}
